import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import "react-toastify/dist/ReactToastify.css";

const LetsConnect = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const onSubmit = async (data) => {
    if (!recaptchaToken) {
      toast.error("Please complete the reCAPTCHA");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/contact.php`, 

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...data, captcha_response: recaptchaToken }),
        }
      );

      const responseData = await response.json();
      console.log("Form submitted successfully:", responseData);
      toast.success("Form submitted successfully!");
      reset();
      setRecaptchaToken(null);
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-start gap-3">
      {/* ToastContainer renders toast notifications */}
      <ToastContainer />
      <div className="mb-4">
        <h1 className="flex items-center flex-wrap lg:flex-nowrap gap-2 whitespace-nowrap text-3xl md:text-4xl text-darkText">
          Have Questions?
          <span className="text-secondaryText">Let's Connect!</span>
        </h1>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Name Input */}
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-darkText mb-2"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              placeholder="Enter your name..."
              {...register("name", { required: "Name is required" })}
              className="w-full px-4 py-3 border border-primaryBorder rounded-lg shadow-sm focus:outline-none"
              disabled={loading}
            />
            {errors.name && (
              <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
            )}
          </div>

          {/* Email Input */}
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-darkText mb-2"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              placeholder="Your email address..."
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: "Invalid email address",
                },
              })}
              className="w-full px-4 py-3 border border-primaryBorder rounded-lg shadow-sm focus:outline-none"
              disabled={loading}
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">
                {errors.email.message}
              </p>
            )}
          </div>
        </div>

        {/* Message Input */}
        <div>
          <label
            htmlFor="message"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Message
          </label>
          <textarea
            id="message"
            placeholder="Enter your message..."
            rows="4"
            {...register("message", { required: "Message is required" })}
            className="w-full px-4 py-3 border min-h-40 border-primaryBorder rounded-lg shadow-sm focus:outline-none"
            disabled={loading}
          ></textarea>
          {errors.message && (
            <p className="text-red-500 text-sm mt-1">
              {errors.message.message}
            </p>
          )}
        </div>

        {/* Submit Button */}
        <div className="flex justify-between gap-4 items-center flex-wrap">
          {/* Google reCAPTCHA */}
          <div className="">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={(token) => setRecaptchaToken(token)}
            />
          </div>
          <button
            type="submit"
            className="bg-darkBg px-6 py-3 text-lg text-white rounded-md hover:bg-secondaryText transition-colors duration-300 ease-in-out"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default LetsConnect;
